/** Display-only slug preview for the create-org drawer (not sent to the API). */
export function previewWorkspaceSlug(name: string): string {
  const slug = name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
  return slug || "…";
}
